import { Ease } from '../Ease';
import { ConfigurationTypes } from '../const/ConfigurationTypes';
import IReelsConfig from '../managers/contracts/configurations/IReelsConfig';
import IReelCascadeProps from '../managers/contracts/configurations/reels/IReelCascadeProps';

export default abstract class BaseReelsConfig implements IReelsConfig {
    type: ConfigurationTypes = ConfigurationTypes.REEL;
    cascadeProps: IReelCascadeProps = {
        mainSpinProps: {
            ///////////////////////////// BASE/MAIN SPIN /////////////////////////////
            spinReelDelay: 80, // 80
            stopReelDelay: 40, // 40
            spinSymbolAnimTime: 800, // 800
            stopSymbolAnimTime: 400, // 400
            spinFirstSymbolAnimTime: 400, // 800
            stopFirstSymbolAnimTime: 200, // 400
            spinSymbolDelay: 40, // 40
            stopSymbolDelay: 20, // 20
            mainDropSpinEasing: "back.inOut(0.6)",
            mainDropStopEasing: "back.out(0.8)",
            /////////////// TURBO MODE ///////////////
            spinReelDelayInTurboMode: 0,
            stopReelDelayInTurboMode: 0,
            spinSymbolAnimTimeInTurboMode: 200,
            stopSymbolAnimTimeInTurboMode: 200,
            spinSymbolDelayInTurboMode: 0,
            stopSymbolDelayInTurboMode: 0,
            mainDropSpinEasingInTurboMode: Ease.None,
            mainDropStopEasingInTurboMode: Ease.None,
            /////////////// TURBO MODE ///////////////
            ///////////////////////////// BASE/MAIN SPIN /////////////////////////////
        },
        dropRemainingProps: {
            animationDuration: 400,
            animationDurationInTurbo: 200,
            delay: 30,
            delayInTurbo: 0,
        },
        fillRemainingProps: {

            animTime: 400, // 800
            animTimeInTurbo: 200, // 800

            easingInTurboMode: Ease.None,
            easing: "back.out(0.8)",

            symbolDelay: 20, // 400
            symbolDelayInTurboMode: 0, // 400

            reelDelay: 40, // 400
            reelDelayInTurboMode: 0, // 400

        },
    };
    /**
     * This must be overwrite in game
     */
    numberOfReels: number = 0;
    /**
     * This must be overwrite in game
     */
    numberOfSymbols: number = 0;
}
